/**
 * What a shopper is told when we cannot ship to their country.
 *
 * One function, because the refusal reaches them down two paths - the add-to-
 * cart 409 and the blocked checkout - and a shopper who sees two different
 * sentences for one situation learns not to trust either.
 *
 * An unsupported country is a shipping decision, not a bug, so the default
 * promises nothing. Canada is the exception and it is a fact rather than a
 * kindness: the courier rate is already configured (APC Parcel Connect
 * Priority International) and the market stays shut until the real landed cost
 * is worked out. Simon, 2026-09-28: "canada is a work in progress we dont sell
 * currently to them because we need to figure out shipping rates etc".
 *
 * SOLDR has said this to Canadians since 2026-09; GLORB said nothing of the
 * kind until now. Hub ledger 2026-09-28-085.
 *
 * REMOVE THE CANADA CASE when Canada opens - or when it is dropped for good.
 * A "just yet" that outlives the intention behind it is worse than a plain no.
 */

const GENERIC = "Sorry - we don't ship to your country.";

/** @type {Record<string, string>} */
const BY_COUNTRY = {
  CA: "We don't ship to Canada just yet - we're working on it.",
};

/**
 * @param {unknown} country ISO-2, any case; anything else falls back.
 * @returns {string}
 */
export function regionUnavailableMessage(country) {
  const iso = typeof country === "string" ? country.trim().toUpperCase() : "";
  return BY_COUNTRY[iso] ?? GENERIC;
}

export { GENERIC as REGION_UNAVAILABLE_MESSAGE };
